import ReactGA from 'react-ga';

const debug = process.env.NODE_ENV === 'development';

const trackPageView = location => {
  ReactGA.set({
    page: location.pathname
  });
  ReactGA.pageview(location.pathname);
};

const initGa = history => {
  ReactGA.initialize(process.env.REACT_APP_GA_IDENTIFIER || 'UA-29349818-3', {
    debug
  });
  if (debug) {
    ReactGA.ga('set', 'sendHitTask', null);
  }
  let currentPath = history.getCurrentLocation();
  trackPageView(currentPath);
  history.listen(trackPageView);
};

export {
  initGa as default,
  trackPageView
};



// WEBPACK FOOTER //
// ./client/ga.js